module.exports = __webpack_public_path__ + "static/media/hidratacion10k.4df3bd4c.webp";